import { useState, useEffect, useCallback } from 'react';

export const useResizeHandlers = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const saved = localStorage.getItem('sidebar-open');
    return saved !== null ? JSON.parse(saved) : true;
  });
  const [chatWidth, setChatWidth] = useState(60);
  const [artifactWidth, setArtifactWidth] = useState(40);

  useEffect(() => {
    const handleResize = () => {
      const newIsMobile = window.innerWidth <= 768;
      setIsMobile(newIsMobile);
      // Only close sidebar on mobile
      if (newIsMobile) {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Call it initially
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = useCallback(() => {
    setIsSidebarOpen(!isSidebarOpen);
  }, [isSidebarOpen]);

  const handleResize = useCallback((newChatWidth, newArtifactWidth) => {
    setChatWidth(newChatWidth);
    setArtifactWidth(newArtifactWidth);
  }, []);

  return {
    isMobile,
    isSidebarOpen,
    setIsSidebarOpen,
    chatWidth,
    artifactWidth,
    toggleSidebar,
    handleResize
  };
};